import type React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { AccessTime, LocationOn, Videocam } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/Index";

interface TimeSlot {
  id: string;
  label: string;
  time: string;
  icon: React.ReactNode;
}

interface TimeAllocationCardProps {
  timeData: {
    call_time: string;
    departure_time: string;
    arrival_at_venue_time: string;
    setup_from_time: string;
    setup_to_time: string;
    shoot_start_time: string;
    shoot_end_time: string;
    estimated_wrap_time: string;
    back_to_base_time: string;
    unpacking_time: string;
    depart_time: string;
  };
}

const TimeAllocationCard: React.FC<TimeAllocationCardProps> = ({
  timeData,
}) => {
  const reduxTheme = useSelector((state: RootState) => state.theme);

  const timeSlots: TimeSlot[] = [
    {
      id: "call_time",
      label: "Call Time",
      time: timeData.call_time,
      icon: <AccessTime />,
    },
    {
      id: "departure_time",
      label: "Departure Time",
      time: timeData.departure_time,
      icon: <AccessTime />,
    },
    {
      id: "arrival_time",
      label: "Arrival At Venue",
      time: timeData.arrival_at_venue_time,
      icon: <LocationOn />,
    },
    {
      id: "setup_from_time",
      label: "Setup From",
      time: timeData.setup_from_time,
      icon: <AccessTime />,
    },
    {
      id: "setup_to_time",
      label: "Setup To",
      time: timeData.setup_to_time,
      icon: <AccessTime />,
    },
    {
      id: "shoot_start",
      label: "Shoot Start Time",
      time: timeData.shoot_start_time,
      icon: <Videocam />,
    },
    {
      id: "shoot_end",
      label: "Shoot End Time",
      time: timeData.shoot_end_time,
      icon: <Videocam />,
    },
    {
      id: "estimated_wrap_time",
      label: "Estimated Wrap",
      time: timeData.estimated_wrap_time,
      icon: <AccessTime />,
    },
    {
      id: "back_to_base_time",
      label: "Back to Base",
      time: timeData.back_to_base_time,
      icon: <LocationOn />,
    },
    {
      id: "unpacking_time",
      label: "Unpacking",
      time: timeData.unpacking_time,
      icon: <AccessTime />,
    },
    {
      id: "depart_time",
      label: "Depart",
      time: timeData.depart_time,
      icon: <AccessTime />,
    },
  ];

  return (
    <Card sx={{ height: "100%", boxShadow: 0 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom fontWeight="bold">
          Time Allocation
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {timeSlots.map((slot) => (
            <Box
              key={slot.id}
              sx={{ display: "flex", alignItems: "center", gap: 2 }}
            >
              <Box sx={{ color: reduxTheme.primary_colors[500] }}>
                {slot.icon}
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography
                  variant="body2"
                  sx={{ color: reduxTheme.primary_colors[300] }}
                >
                  {slot.label}
                </Typography>
                <Typography variant="body1" fontWeight="medium">
                  {slot.time}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default TimeAllocationCard;
